/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React, { Fragment } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Component imports
import Permissioned from '../components/Permissioned';
import DocumentTitle from '../components/DocumentTitle';
import AutomatedAgentTestsTable from '../components/Tables/AutomatedAgentTestsTable';

// Misc imports
import { PERMISSIONS_GROUP_ADMIN } from '../constants/main';
import useUserPermissions from '../utils/hooks/useUserPermissions';

const AutomatedAgentTestsScreen = () => {
  const { orgId } = useParams();
  const { t } = useTranslation();
  const userPermissions = useUserPermissions(orgId, null);

  return (
    <Fragment>
      <DocumentTitle title={t('Testing')} />

      <Permissioned
        allowedPermissions={PERMISSIONS_GROUP_ADMIN}
        currentPermissions={userPermissions}
      >
        <AutomatedAgentTestsTable />
      </Permissioned>
    </Fragment>
  );
};

export default AutomatedAgentTestsScreen;
